import type { Slide, IntroCardSlide, QuestionSlide } from "../types";

const preloadedUrls = new Set<string>();

export function preloadImage(url?: string | null) {
    if (!url || preloadedUrls.has(url)) return;

    preloadedUrls.add(url);

    const img = new Image();
    img.src = url;
}

export function extractImageUrlsFromHtml(html?: string | null): string[] {
    if (!html) return [];

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const imgs = Array.from(doc.querySelectorAll("img"));
    return imgs
        .map((img) => img.getAttribute("src"))
        .filter((src): src is string => !!src);
}

export function collectImageUrlsFromSlide(slide: Slide): string[] {
    const urls: string[] = [];

    switch (slide.kind) {
        case "introBasic":
            if (slide.image?.url) urls.push(slide.image.url);
            break;
        case "introCard": {
            const s = slide as IntroCardSlide;

            if (s.mainImage?.url) urls.push(s.mainImage.url);

            s.iconRow?.forEach((img) => {
                if (img.url) urls.push(img.url);
            });

            if (s.subCard?.images?.length) {
                s.subCard.images.forEach((img) => {
                    if (img.url) urls.push(img.url);
                });
            }
            break;
        }
        case "question": {
            const q = slide as QuestionSlide;

            if (q.image?.url) urls.push(q.image.url);

            if (q.feedback?.image?.url) {
                urls.push(q.feedback.image.url);
            }

            if (q.feedback?.bodyHtml) {
                const htmlImgs = extractImageUrlsFromHtml(q.feedback.bodyHtml);
                urls.push(...htmlImgs);
            }
            break;
        }
        case "shareSlide":
            if (slide.images?.length) {
                slide.images?.forEach((image) => {
                    urls.push(image.url);
                });
            }
            break;
    }
    return urls;
}
